/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module,Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaStockistsViewProps } from './citta-stockists';

const CittaStockistsViewProps: React.FC<ICittaStockistsViewProps> = props => {
    const { createStockistsAddress,stockistMain,StockistContainer,stockistTop,createCountryDropDown,createCityStateDropDown,createSearchAddress } = props;
    if(!props.createStockistsAddress) {
        return null;
    }
    return(
        <Module {...StockistContainer}>
            <Node {...stockistTop}>
                {createCountryDropDown}
                {createCityStateDropDown}
                {createSearchAddress}
            </Node>

            <Node {...stockistMain}>
                {/* <Node {...stockistGrid}> */}
                { createStockistsAddress}
                {/* </Node> */}
            </Node>
        </Module>
    );
};

export default CittaStockistsViewProps;
